import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=681b5916&scoped=true"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=681b5916&lang=scss"
import style1 from "./Charges.vue?vue&type=style&index=1&id=681b5916&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b5916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681b5916')) {
      api.createRecord('681b5916', component.options)
    } else {
      api.reload('681b5916', component.options)
    }
    module.hot.accept("./Charges.vue?vue&type=template&id=681b5916&scoped=true", function () {
      api.rerender('681b5916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Charges.vue"
export default component.exports